import Joi from 'joi';
import { formatErrorMessage } from 'validation/commonValidators';
import { IBANvalidationSchema } from '../../../Onboarding/helpers';
import { TransferFieldNames, CommunicationTypes } from '../../helpers';
import { structuredCommunicationPatternWithPlus } from 'utils/constants';
import { round } from 'utils/math';

export const MIN_TRANSFER_AMOUNT = 0.01;

/**
 * Shared amount validation schema for transfer forms
 * Validates that amount is at least MIN_TRANSFER_AMOUNT and doesn't exceed source account balance
 */
export const transferAmountSchema = (sourceAccountBalance?: number) =>
  Joi.number()
    .min(MIN_TRANSFER_AMOUNT)
    .custom((value, helpers) => {
      const roundedValue = round(value, 100);
      // Only check maximum when balance is available
      if (
        typeof sourceAccountBalance === 'number' &&
        roundedValue > sourceAccountBalance
      ) {
        return helpers.error('number.max');
      }

      return roundedValue;
    })
    .required()
    .messages(
      formatErrorMessage('accountable_banking', TransferFieldNames.amount),
    );

export const externalTransferSchema = (sourceAccountBalance?: number) =>
  Joi.object({
    [TransferFieldNames.recipient_name]: Joi.string()
      .required()
      .messages(
        formatErrorMessage(
          'accountable_banking',
          TransferFieldNames.recipient_name,
        ),
      ),
    [TransferFieldNames.recipient_iban]: IBANvalidationSchema,
    [TransferFieldNames.amount]: transferAmountSchema(sourceAccountBalance),
    [TransferFieldNames.communication]: Joi.when(
      TransferFieldNames.communication_type,
      {
        is: CommunicationTypes.structured,
        then: Joi.string().pattern(structuredCommunicationPatternWithPlus),
      },
    )
      .allow('', null)
      .messages(
        formatErrorMessage(
          'accountable_banking',
          TransferFieldNames.communication,
        ),
      ),
    [TransferFieldNames.firstExecutionDate]: Joi.date().required(),
    [TransferFieldNames.period]: Joi.string().required(),
    [TransferFieldNames.lastExecutionDate]: Joi.optional(),
  });
